module.exports = __webpack_public_path__ + "static/media/step-3.814447d5.png";